var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"null-container"},[(_vm.showImg)?_c('img',{style:({width: `${_vm.imgWidth}px`}),attrs:{"src":require("@/static/images/null/empty.png")}}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }